// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-7e124521] {\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin-bottom: 0.3rem;\n}\n.title .p1[data-v-7e124521] {\n    font-size: 0.16rem;\n    color: #000;\n    position: absolute;\n    left: 0;\n    font-weight: bold;\n}\n.title .p2[data-v-7e124521] {\n    color: #606266;\n    font-size: 0.12rem;\n    border-bottom: 1px solid #b4b2b2;\n    margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
